import { Helmet } from "react-helmet-async";
import { COMPANY } from "../data/company";

export default function SEO({ title, description, path = "", image = "/_assets/hero-toemrer-arbejde.jpg" }) {
  const fullTitle = title ? `${title} - ${COMPANY.name}` : COMPANY.name;
  const defaultDesc = `${COMPANY.name} i ${COMPANY.city} er specialister i døre & vinduer, træterrasser og udendørsarealer samt indendørs renovering af lofter og vægge. Kontakt Andreas på ${COMPANY.phone}.`;
  const metaDescription = description || defaultDesc;
  const canonicalUrl = typeof window !== "undefined" ? window.location.origin + path : path;
  const imageUrl = image.startsWith("http") ? image : `https://assets.auxodev.dk${image}`;

  const schemaOrg = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": COMPANY.name,
    "image": imageUrl,
    "telephone": "+4561287153",
    "email": COMPANY.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": COMPANY.street,
      "addressLocality": "Skårup Fyn",
      "postalCode": "5881",
      "addressCountry": "DK"
    },
    "founder": {
      "@type": "Person",
      "name": COMPANY.contactPerson
    },
    "taxID": COMPANY.cvr,
    "sameAs": [
      COMPANY.facebook
    ]
  };

  return (
    <Helmet>
      <html lang="da" />
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:site_name" content={COMPANY.name} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content="da_DK" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrg)}
      </script>
    </Helmet>
  );
}
